import React from "react";

const ManageUsersPage = () => {
  return <div>ManageUsersPage</div>;
};

export default ManageUsersPage;
